package com.patronat.top.core.network

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.error.AppErrorCode

sealed class NetworkResult<out T> {

    data class Success<out T>(val data: T) : NetworkResult<T>()

    data class Error(
        val type: AppErrorCode,
        val message: String? = null,
        val throwable: Throwable? = null
    ) : NetworkResult<Nothing>()

}

inline fun <T, R> NetworkResult<T>.asDomainResult(mapper: (T) -> R): DomainResult<R> {
    return when (this) {
        is NetworkResult.Success -> {
            DomainResult.Success(mapper(this.data))
        }
        is NetworkResult.Error -> {
            DomainResult.Error(type  = this.type, message = this.message, throwable = this.throwable)
        }
    }
}